export const getFiltersForRequest = ({ filters }) => {
    return _.mapKeys(filters, (value, key) => {
        return `filters[${key}]`;
    });
};

export const firstApprovedEntry = (state) => {
    if (! state.selectedPerson) {
        return null;
    }

    let approvedEntries = state.selectedPerson.upcoming_entries
        .filter(entry => entry.is_approved);

    return approvedEntries.length > 0 ? approvedEntries[0] : null;
};

export const hasManyEntries = (state) => {
    if (! state.selectedPerson) {
        return false;
    }

    let approvedEntries = state.selectedPerson.upcoming_entries;

    return approvedEntries.length > 1;
};